export function dataInRequest(params = {}) {
    return {
        type: '@manutretrasmitirunilog/DATA_IN_REQUEST',
        payload: { params },
    };
}

export function findData(id) {
    return {
        type: '@manutretrasmitirunilog/FIND_DATA',
        payload: { id },
    };
}

export function failedRequest() {
    return {
        type: '@manutretrasmitirunilog/FAILED_REQUEST',
    };
}


export function updateData(data, params) {
    return {
        type: '@manutretrasmitirunilog/UPDATE_DATA',
        payload: { data, params },
    };
}


export function storeData(data, params) {
    return {
        type: '@manutretrasmitirunilog/STORE_DATA',
        payload: { data, params },
    };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
    return {
        type: '@manutretrasmitirunilog/SUCCESS_IN_REQUEST',
        payload: { data, page, pageSize, totalCount, totalPages },
    };
}

export function successRequest(data) {
    return {
        type: '@manutretrasmitirunilog/SUCCESS_REQUEST',
        payload: { data },
    };
}

export function successRemove(params) {
    return {
        type: '@manutretrasmitirunilog/SUCCESS_REMOVE',
        payload: { params },
    };
}

export function recordFiltering(params) {
    return {
        type: '@manutretrasmitirunilog/RECORD_FILTERING',
        payload: { params },
    };
}